import type { BlendMode } from '@wix/background-media-utils';
import tnKeys from './TextMask.inspector.translations.json';

export const mediaDefaults = {
  gradient: {
    showOverlayForMediaType: 'all',
    fittingType: 'fill',
    alignType: 'center',
    colorOverlay: '',
    colorOverlayOpacity: 0,
    color: '#FAFAFA',
    colorOpacity: 1,
    type: 'BackgroundMedia',
    colorLayers: [
      {
        type: 'GradientLinearLayer',
        opacity: 1,
        fill: {
          type: 'GradientLinear',
          colorStops: [
            {
              size: {
                value: 17.010498046875,
                type: 'percentage',
              },
              color: 'color_28',
            },
            {
              size: {
                value: 48.2696533203125,
                type: 'percentage',
              },
              color: 'color_21',
            },
            {
              size: {
                value: 80.902099609375,
                type: 'percentage',
              },
              color: 'color_18',
            },
          ],
          angle: 50.498759152186665,
        },
      },
    ],
  },
  media: {
    fittingType: 'fill',
    alignType: 'center',
    colorOverlay: '',
    colorOverlayOpacity: 0,
    color: '#ffffff',
    colorOpacity: 0,
    colorLayers: [
      {
        type: 'SolidColorLayer',
        opacity: 0,
        fill: { type: 'SolidColor', color: '#ffffff' },
      },
    ],
    type: 'BackgroundMedia',
    showOverlayForMediaType: 'all',
    mediaRef: {
      type: 'WixVideo',
      title: 'Forest',
      videoId: '11062b_d578b9d4ffba48c68d086ec29fe9e6f0',
      duration: 40.8,
      posterImageRef: {
        type: 'Image',
        width: 1920,
        height: 1080,
        uri: '11062b_d578b9d4ffba48c68d086ec29fe9e6f0f000.jpg',
        description: '',
        title: '',
        alt: '',
      },
      qualities: [
        {
          width: 854,
          height: 480,
          quality: '480p',
          url: 'video/11062b_d578b9d4ffba48c68d086ec29fe9e6f0/480p/mp4/file.mp4',
        },
        {
          width: 1280,
          height: 720,
          quality: '720p',
          url: 'video/11062b_d578b9d4ffba48c68d086ec29fe9e6f0/720p/mp4/file.mp4',
        },
        {
          width: 1920,
          height: 1080,
          quality: '1080p',
          url: 'video/11062b_d578b9d4ffba48c68d086ec29fe9e6f0/1080p/mp4/file.mp4',
        },
      ],
      adaptiveVideo: [
        {
          format: 'hls',
          url: 'site/media/video/11062b_d578b9d4ffba48c68d086ec29fe9e6f0/da01a1fc-ad34-44bc-90e8-cc9413c466e6/repackage/hls',
        },
      ],
      artist: {
        name: 'gettyimages',
        id: '117972864',
      },
      hasAudio: false,
      fps: '25/1',
      opacity: 1,
      autoplay: true,
      loop: true,
      preload: 'auto',
      mute: true,
    },
  },
} as const;

export const HEADING_LEVELS = {
  H1: 1,
  H2: 2,
  H3: 3,
  H4: 4,
  H5: 5,
  H6: 6,
  P: 0,
  '⏤': -1,
} as const;

export const COLOR_PICKER_X_OFFSET = 0;
export const COLOR_PICKER_Y_OFFSET = 35;
export const BLEND_MODES = [
  {
    label: 'inspector.Inspector-TextEffects.Section-Fill.Blending.Normal',
    value: 'normal',
  },

  {
    label: 'inspector.Inspector-TextEffects.Section-Fill.Blending.ColorBurn',
    value: 'colorBurn',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Multiply',
    value: 'multiply',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Screen',
    value: 'screen',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Overlay',
    value: 'overlay',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Darken',
    value: 'darken',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Lighten',
    value: 'lighten',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.ColorDodge',
    value: 'colorDodge',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.HardLight',
    value: 'hardLight',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.SoftLight',
    value: 'softLight',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Difference',
    value: 'difference',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Exclusion',
    value: 'exclusion',
  },
  {
    label: 'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Hue',
    value: 'Hue',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Saturation',
    value: 'saturation',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Color',
    value: 'color',
  },
  {
    label:
      'inspector.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Luminosity',
    value: 'luminosity',
  },
];
export const mediaCategory = 'BG_MEDIA';

export const BLEND_MODES_BASE: Partial<Record<BlendMode, string>> = {
  normal: tnKeys.overlay_blend_normal,
  colorBurn: tnKeys.overlay_blend_colorBurn,
  multiply: tnKeys.overlay_blend_multiply,
  screen: tnKeys.overlay_blend_screen,
  overlay: tnKeys.overlay_blend_overlay,
  darken: tnKeys.overlay_blend_darken,
  lighten: tnKeys.overlay_blend_lighten,
  colorDodge: tnKeys.overlay_blend_colorDodge,
  hardLight: tnKeys.overlay_blend_hardLight,
  softLight: tnKeys.overlay_blend_softLight,
  difference: tnKeys.overlay_blend_difference,
  exclusion: tnKeys.overlay_blend_exclusion,
};

export const BLEND_MODES_IMG_ONLY: Partial<Record<BlendMode, string>> = {
  hue: tnKeys.overlay_blend_hue,
  saturation: tnKeys.overlay_blend_saturation,
  color: tnKeys.overlay_blend_color,
  luminosity: tnKeys.overlay_blend_luminosity,
};
